module.exports = __webpack_public_path__ + "static/media/intrucept_logo.b8af00c4.svg";